import { render, staticRenderFns } from "./ForRecord.vue?vue&type=template&id=749d6ad4&scoped=true&"
import script from "./ForRecord.vue?vue&type=script&lang=js&"
export * from "./ForRecord.vue?vue&type=script&lang=js&"
import style0 from "./ForRecord.vue?vue&type=style&index=0&id=749d6ad4&lang=scss&scoped=true&"
import style1 from "./ForRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d6ad4",
  null
  
)

export default component.exports